import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorRegistryValueRuleFormWebComponent } from '../component/IntegrityMonitorRegistryValueRuleFormWebComponent';
import { IntegrityMonitorRegistryValueRuleFormView } from '../view/IntegrityMonitorRegistryValueRuleFormView';
import { template } from '../view/template';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';

export class IntegrityMonitorRegistryValueRuleFormController extends BaseWebComponentController {
  public view!: IntegrityMonitorRegistryValueRuleFormView;

  constructor(component: IntegrityMonitorRegistryValueRuleFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrityMonitorRegistryValueRuleFormView,
      viewTemplate: template,
    });
  }

  public resetFields() {
    // discard changes and skip validation
    this.view.formGroup.applyToFormGroupFields(field => {
      if (field instanceof GzFormFieldWebComponent) {
        field.discardChanges();
        field.resetField();
      }
    });
  }
}
